export const VNWALLET_OPEN_BADGE_DIALOG = 'VNWALLET_OPEN_BADGE_DIALOG'
export const VNWALLET_OPEN_EXCHANGE_SERVICE_DIALOG = 'VNWALLET_OPEN_EXCHANGE_SERVICE_DIALOG'
export const VNWALLET_OPEN_PAYMENT_UPDATES_DIALOG = 'VNWALLET_OPEN_PAYMENT_UPDATES_DIALOG'
export const VNWALLET_OPEN_GIFT_CARD_TRANSFER_DIALOG = 'VNWALLET_OPEN_GIFT_CARD_TRANSFER_DIALOG'
